/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SidebarLayout from "../Components/sidebar/SidebarLayout";
import { AddListingFragment } from "../fragments";

function AddListing() {
  const navigate = useNavigate();

  const Check = () => {
    const Token = localStorage.getItem("token");
    if (Token) {
      return true;
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    Check(); // Call the Check function
  }, []); // Pass an empty dependency array

  return (
    <>
      <SidebarLayout>
        <AddListingFragment />
      </SidebarLayout>
    </>
  );
}

export default AddListing;
